/** Пустая строка/undefined трактуется как отсутствие значения. */
export const isBlank = (value: string | undefined | null): boolean =>
  value === undefined || value === null || value.trim() === ""

/** Валиден ли JSON (пустая строка считается валидной — «нет значения»). */
export const isValidJson = (value: string | undefined | null): boolean => {
  if (isBlank(value)) return true
  try {
    JSON.parse(value as string)
    return true
  } catch {
    return false
  }
}

/**
 * Разбирает JSON-строку в значение.
 * Пустая строка → undefined. Невалидный JSON → бросает SyntaxError.
 */
export const parseJsonValue = <T = unknown>(
  value: string | undefined | null,
): T | undefined => {
  if (isBlank(value)) return undefined
  return JSON.parse(value as string) as T
}

/** Безопасно сериализует значение в отформатированную JSON-строку. */
export const stringifyJson = (value: unknown): string => {
  if (value === undefined) return ""
  try {
    return JSON.stringify(value, null, 2)
  } catch {
    return ""
  }
}

/** Форматирует значение в компактную однострочную JSON-превью (SPEC §4.1). */
export const previewJson = (value: unknown, maxLen = 120): string => {
  if (value === null || value === undefined) return "—"
  try {
    const s = JSON.stringify(value)
    return s.length > maxLen ? `${s.slice(0, maxLen)}…` : s
  } catch {
    return String(value)
  }
}
